import React, {useState, useEffect } from 'react'
import { Box, SimpleGrid, TextInput, Select, Loader, Text, Paper } from '@mantine/core'
import { useUserGeneralFormContext } from '../hook/user-general-form'
import { getAllCountryList, getAllCityList } from '../../../../../../services/location'
import { useDebouncedCallback } from '@mantine/hooks'

const defaultStatusList = [
  {
    label: 'Active',
    value: 'true'
  },
  {
    label: 'Inactive',
    value: 'false'
  }
]

const defaultCanOrderList = [
  {
    label: 'Trading',
    value: 'trading'
  },
  {
    label: 'Forwarding',
    value: 'forwarding'
  }
]

const defaultSurveyList = [
  {
    label: 'Did not choose',
    value: '0'
  },
  {
    label: 'Search Engine (Google,etc.)',
    value: '1'
  },
  {
    label: 'Referral',
    value: '2'
  },
  {
    label: 'Email Newsletter',
    value: '3'
  },
  {
    label: 'WhatsApp or Broadcast',
    value: '4'
  },
  {
    label: 'Telegram',
    value: '5'
  },
  {
    label: 'Facebook',
    value: '6'
  },
  {
    label: 'Instagram',
    value: '7'
  },
  {
    label: 'LinkedIn',
    value: '8'
  },
  {
    label: 'Youtube',
    value: '9'
  },
  {
    label: 'Others (Specify)',
    value: '10'
  }
]

const UserInformation = () => {
  const form = useUserGeneralFormContext()

  // country
  const [countryList, setCountryList] = useState([])
  const [loadingCountry, setLoadingCountry] = useState(true)

  // city
  const [cityList, setCityList] = useState([])
  const [loadingCity, setLoadingCity] = useState([])

   const handleGetListCountry = useDebouncedCallback(async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }, 300)

  const handleGetListCity = useDebouncedCallback(async (idCountry) => {
    setLoadingCity(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'filter[countries.id][is]': idCountry,
      'fields[City]': 'name',
    }
    try {
      const response = await getAllCityList(parameter)
      const dataCity = response.data
      const remapDataCity = dataCity.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCityList(remapDataCity)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCity(false)
    }
  }, 300)

  form.watch('country_signup', ({ previousValue, value }) => {
    if (previousValue) {
      if (previousValue !== value) {
        form.setValues((prev) => ({ ...prev, city_signup: null }))
        setCityList([])
      }
    }
    if (value !== null) {
      handleGetListCity(value)
      form.setValues((prev) => ({ ...prev, country_signup: value }))
    } else {
      setCityList([])
      form.setValues((prev) => ({ ...prev, city_signup: null }))
    }
  })

  useEffect(() => {
    handleGetListCountry()
    // eslint-disable-next-line
  }, [])

  const handleChangeFormNoSpace = (name, val) => {
    form.setValues((prev) => ({...prev, [name]: val.trim()}))
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }
  return (
    <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
      <Text fw={500}>
        User Information
      </Text>
      <SimpleGrid my='lg' cols={4} spacing='lg' verticalSpacing='lg'>
        <TextInput
          label="Fullname"
          placeholder="Input Fullname Here"
          key={form.key('name')}
          {...form.getInputProps('name')}
          withAsterisk
          size='xs'
        />

        <TextInput
          label="Email"
          placeholder="Input Email Here"
          key={form.key('email')}
          {...form.getInputProps('email')}
          withAsterisk
          size='xs'
        />

        <TextInput
          label="Phone"
          placeholder="Input Phone Here"
          key={form.key('phone')}
          {...form.getInputProps('phone')}
          withAsterisk
          size='xs'
        />

        <Select
          label="Active"
          data={defaultStatusList}
          key={form.key('active')}
          {...form.getInputProps('active')}
          allowDeselect={false}
          size='xs'
          withAsterisk
        />

        <Select
          label="Country Signup"
          data={countryList}
          key={form.key('country_signup')}
          {...form.getInputProps('country_signup')}
          searchable
          clearable
          autoSelectOnBlur
          nothingFoundMessage={!loadingCountry ? countryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
          allowDeselect={false}
          withAsterisk
          size='xs'
        />

        <Select
          label="City Signup"
          data={cityList}
          key={form.key('city_signup')}
          {...form.getInputProps('city_signup')}
          searchable
          clearable
          autoSelectOnBlur
          nothingFoundMessage={!loadingCity ? cityList.length > 0 ? '' : 'No City Found' : loadingDataTemplate()}
          disabled={form.values.country_signup === null}
          allowDeselect={false}
          withAsterisk
          size='xs'
        />

        <TextInput
          label="Referral Code"
          placeholder="Input Referral Code Here"
          {...form.getInputProps('referral_code')}
          onChange={(val) => handleChangeFormNoSpace('referral_code', val.target.value)}
          size='xs'
        />

        <Select
          label="Survey"
          data={defaultSurveyList}
          key={form.key('survey')}
          {...form.getInputProps('survey')}
          allowDeselect={false}
          size='xs'
        />

        <Select
          label="Can Order"
          data={defaultCanOrderList}
          key={form.key('can_order')}
          {...form.getInputProps('can_order')}
          allowDeselect={false}
          size='xs'
        />

      </SimpleGrid>
    </Paper>
  )
}

export default UserInformation